// src/pages/terms/TermsOfUse.jsx

import { Link } from "react-router-dom";
import Hero from "../../components/Hero";
import "./TermsOfUse.css";

export default function TermsOfUse() {
  return (
    <>
      {/* site nav */}

      {/* hero/banner */}
      <Hero
        title="Terms of Use"
        // subtitle="Please read these terms carefully"
        mediaType="image"
      />

      {/* main content */}
      <main className="terms-content container">
        <p className="terms-content__date">
          <strong>Effective Date:</strong> 6.23.2025
        </p>

        <p>
          Welcome to the official website of George Sotirov. By accessing or
          using this website, you agree to be bound by the following terms and
          conditions. If you do not agree with these terms, please do not use
          this site.
        </p>

        <p>
          Unless explicitly stated otherwise, no part of this website may be
          copied, reproduced, distributed, modified, or used in any form without
          prior written permission from the owner.
        </p>

        <h2>1. Intellectual Property</h2>
        <p>
          All content on this website — including but not limited to videos,
          images, animations, audio, graphics, logos, and written text — is the
          intellectual property of George Sotirov and is protected under
          applicable copyright and intellectual property laws.
        </p>
        <p>
          Unless explicitly stated otherwise, no part of this website may be
          copied, reproduced, distributed, modified, or used in any form without
          prior written permission from the owner.
        </p>

        <h2>2. Limited Use</h2>
        <p>
          Visitors may view and share links to public content for personal and
          non-commercial use only. However, any direct downloading,
          redistribution, or reuse of content (especially for commercial
          purposes or public presentation) is{" "}
          <strong>strictly prohibited without written authorization.</strong>
        </p>
        <p>
          Some works or projects may be licensed or shared under special terms —
          if so, those terms will be clearly stated next to the specific
          content.
        </p>

        <h2>3. Misuse of Content</h2>
        <p>
          Any unauthorized use of media from this site, including re-editing, AI
          training, or commercial adaptation, constitutes a violation of these
          terms and may result in legal action.
        </p>

        <h2>4. External Links</h2>
        <p>
          This website may contain links to third-party platforms (e.g.,
          YouTube, Vimeo, Instagram). These platforms are governed by their own
          terms of use and privacy policies, which users should review
          independently.
        </p>

        <h2>5. Changes to These Terms</h2>
        <p>
          These Terms of Use may be updated from time to time without prior
          notice. By continuing to use the site, you agree to the most current
          version of these terms.
        </p>

        <h2>6. Contact</h2>
        <p>
          For permissions, inquiries, or collaborations, please use the{" "}
          <Link to="/contact" className="terms-link">
            Contact Page
          </Link>{" "}
          or reach out via email at{" "}
          <a href="mailto:gsotirovapm@gmail.com" className="terms-link">
            gsotirovapm@gmail.com
          </a>
          ,{" "}
          <a href="mailto:contact@georgesotirov.com" className="terms-link">
            contact@georgesotirov.com
          </a>
          .
        </p>

        <h2>7. Misuse of Contact Information</h2>
        <p>
          Any contact information (including email address, phone number, or
          social links) listed on this website is provided{" "}
          <strong>solely for professional inquiries</strong> (project proposals,
          job opportunities, collaboration requests, etc.). You{" "}
          <strong>may not collect, store, sell, or use</strong> this information
          for spam, marketing, scams, or any other unrelated or malicious
          purposes. Doing so will be considered a breach of these terms and{" "}
          <strong>may lead to legal consequences.</strong>
        </p>
      </main>

      {/* site footer */}
    </>
  );
}
